module.exports = __webpack_public_path__ + "static/media/peavey-speakers.0c2bbf5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProAudioPage/assets/peavey-speakers.png
// module id = 529
// module chunks = 0